<script setup lang="ts">
import { Typography } from '@apparatix/library/core';

type Props = {
  empty: boolean;
}

const props = defineProps<Props>();
</script>
<template>
  <Typography v-if="!props.empty" variant="body" muted>
    Unable to parse AI response. Please regenerate this section (this will not count against your remaining attempts)
  </Typography>
  <Typography v-else variant="body" muted>
    Empty
  </Typography>
</template>
